// src/components/LoginPage.js

import React from 'react';
import { Box, Typography, Button } from '@mui/material';

function LoginPage() {
  const loginWithDiscord = () => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    window.location.href = `${backendUrl}/auth/discord`;
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', overflow: 'hidden' }}>
      {/* Left Panel - Gradient Art */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flex: 1,
          background: 'linear-gradient(135deg, #0f1318 0%, #1a237e 50%, #0d47a1 100%)',
          position: 'relative',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {/* Decorative circles */}
        <Box
          sx={{
            position: 'absolute',
            width: 400,
            height: 400,
            borderRadius: '50%',
            background: 'rgba(92, 107, 192, 0.08)',
            top: -100,
            left: -100,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: 250,
            height: 250,
            borderRadius: '50%',
            background: 'rgba(66, 165, 245, 0.06)',
            bottom: 60,
            right: -60,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: 180,
            height: 180,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
            top: '35%',
            left: '10%',
          }}
        />

        {/* Logo mark */}
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #5c6bc0, #42a5f5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            fontSize: '1.5rem',
            color: '#fff',
            mb: 3,
            zIndex: 1,
          }}
        >
          HN
        </Box>

        <Typography variant="h3" sx={{ color: '#fff', fontWeight: 700, zIndex: 1 }}>
          Highland Networks
        </Typography>
        <Typography variant="h5" sx={{ color: 'rgba(255,255,255,0.7)', fontWeight: 400, mt: 1, zIndex: 1 }}>
          Bot Management Platform
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: 'rgba(255,255,255,0.4)', mt: 3, zIndex: 1, maxWidth: 340, textAlign: 'center', lineHeight: 1.7 }}
        >
          Monitor, configure, and manage your Discord modmail bots from a single dashboard.
        </Typography>
      </Box>

      {/* Right Panel - Login Card */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#0f1318',
          px: 4,
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 400 }}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 1, color: '#fff' }}>
            Welcome back
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.5)', mb: 4 }}>
            Sign in with your Discord account to continue.
          </Typography>

          <Button
            variant="contained"
            onClick={loginWithDiscord}
            fullWidth
            size="large"
            sx={{
              py: 1.5,
              bgcolor: '#5865F2',
              '&:hover': { bgcolor: '#4752C4' },
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              borderRadius: '10px',
            }}
          >
            {/* Discord SVG icon */}
            <svg width="24" height="24" viewBox="0 0 71 55" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9225 44.6363 54.2947 44.9293 54.5765 45.2082C54.7052 45.304 54.6968 45.5041 54.5569 45.5858C52.7882 46.6197 50.9496 47.4931 49.0157 48.2228C48.8899 48.2707 48.8339 48.4172 48.8955 48.5383C49.9221 50.6034 51.1395 52.5699 52.5024 54.4350C52.6324 54.5139 52.7332 54.5477 52.8256 54.5195C58.6271 52.7249 64.5097 50.0174 70.5862 45.5576C70.6389 45.5182 70.6680 45.4590 70.6680 45.3942C72.1427 30.0791 68.1710 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.2250 20.1717 23.0133 23.7259 23.0133C27.3080 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.2800 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.2250 43.7636 23.0133 47.3178 23.0133C50.8999 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.8999 37.3253 47.3178 37.3253Z"
                fill="currentColor"
              />
            </svg>
            Sign in with Discord
          </Button>
        </Box>

        <Typography
          variant="caption"
          sx={{ color: 'rgba(255,255,255,0.2)', position: 'absolute', bottom: 24 }}
        >
          Powered by Highland Networks
        </Typography>
      </Box>
    </Box>
  );
}

export default LoginPage;
